import Mileage from './Mileage';

export default Mileage;
